// Mock data for development and testing

// Mock customers
export const mockCustomers = [
  { id: 1, name: 'Acme Inc.', contact: 'John Doe', email: 'john@acme.com' },
  { id: 2, name: 'Globex Corp.', contact: 'Jane Smith', email: 'jane@globex.com' },
  { id: 3, name: 'Initech', contact: 'Mike Johnson', email: 'mike@initech.com' }
];

// Mock projects by customer
export const mockProjects = {
  1: [ // Acme Inc.
    { id: 101, name: 'Website Redesign' },
    { id: 102, name: 'SEO Optimization' },
    { id: 103, name: 'Content Creation' }
  ],
  2: [ // Globex Corp.
    { id: 201, name: 'App Development' },
    { id: 202, name: 'System Integration' },
    { id: 203, name: 'IT Consulting' }
  ],
  3: [ // Initech
    { id: 301, name: 'Database Migration' },
    { id: 302, name: 'Server Maintenance' },
    { id: 303, name: 'Network Security' }
  ]
};

// Mock employees
export const mockEmployees = [
  { id: 101, name: 'John Smith', email: 'john.smith@example.com', position: 'Senior Developer' },
  { id: 102, name: 'Jane Doe', email: 'jane.doe@example.com', position: 'UI/UX Designer' },
  { id: 103, name: 'Alex Johnson', email: 'alex.johnson@example.com', position: 'Project Manager' }
];

// Helper function to get date string for today or relative days
const getDateString = (daysFromToday = 0) => {
  const date = new Date();
  date.setDate(date.getDate() + daysFromToday);
  return date.toISOString().split('T')[0];
};

// Mock time entries
export const mockTimeEntries = [
  { 
    id: 1, 
    employeeId: 101, 
    employeeName: 'John Smith',
    customerId: 1, 
    customerName: 'Acme Inc.',
    projectId: 101,
    projectName: 'Website Redesign',
    date: getDateString(0), // Today
    hours: 8, 
    description: 'Implemented new homepage design',
    status: 'approved',
    history: [
      { 
        timestamp: new Date().toISOString(), 
        action: 'Created by John Smith'
      },
      { 
        timestamp: new Date().toISOString(), 
        action: 'Approved by Customer Admin'
      }
    ]
  },
  { 
    id: 2, 
    employeeId: 101,
    employeeName: 'John Smith',
    customerId: 2, 
    customerName: 'Globex Corp.',
    projectId: 201,
    projectName: 'App Development',
    date: getDateString(-1), // Yesterday
    hours: 7.5, 
    description: 'Created API endpoints for user authentication',
    status: 'pending',
    history: [
      { 
        timestamp: new Date(new Date().setDate(new Date().getDate() - 1)).toISOString(), 
        action: 'Created by John Smith'
      }
    ]
  },
  { 
    id: 3, 
    employeeId: 101,
    employeeName: 'John Smith',
    customerId: 3, 
    customerName: 'Initech',
    projectId: 301,
    projectName: 'Database Migration',
    date: getDateString(-2), // 2 days ago
    hours: 6, 
    description: 'Migrated customer data to new database schema',
    status: 'challenged',
    challengeReason: 'Hours seem excessive for the task described',
    history: [
      { 
        timestamp: new Date(new Date().setDate(new Date().getDate() - 2)).toISOString(), 
        action: 'Created by John Smith'
      },
      { 
        timestamp: new Date(new Date().setDate(new Date().getDate() - 1)).toISOString(), 
        action: 'Challenged by Customer Admin',
        note: 'Hours seem excessive for the task described'
      }
    ]
  },
  { 
    id: 4, 
    employeeId: 101,
    employeeName: 'John Smith',
    customerId: 1, 
    customerName: 'Acme Inc.',
    projectId: 101,
    projectName: 'Website Redesign',
    date: getDateString(1), // Tomorrow
    hours: 8, 
    description: 'Optimized image loading and implemented lazy loading',
    status: 'approved',
    history: [
      { 
        timestamp: new Date(new Date().setDate(new Date().getDate() + 1)).toISOString(), 
        action: 'Created by John Smith'
      },
      { 
        timestamp: new Date(new Date().setDate(new Date().getDate() + 1)).toISOString(), 
        action: 'Approved by Customer Admin'
      }
    ]
  },
  { 
    id: 5, 
    employeeId: 101,
    employeeName: 'John Smith',
    customerId: 2, 
    customerName: 'Globex Corp.',
    projectId: 201,
    projectName: 'App Development',
    date: getDateString(2), // 2 days from now
    hours: 8, 
    description: 'Implemented state management with Redux',
    status: 'approved',
    history: [
      { 
        timestamp: new Date(new Date().setDate(new Date().getDate() + 2)).toISOString(), 
        action: 'Created by John Smith'
      },
      { 
        timestamp: new Date(new Date().setDate(new Date().getDate() + 2)).toISOString(), 
        action: 'Approved by Customer Admin'
      }
    ]
  },
  { 
    id: 6, 
    employeeId: 102,
    employeeName: 'Jane Doe',
    customerId: 3, 
    customerName: 'Initech',
    projectId: 302,
    projectName: 'Server Maintenance',
    date: getDateString(3), // 3 days from now
    hours: 4, 
    description: 'Updated server packages and security patches',
    status: 'approved',
    history: [
      { 
        timestamp: new Date(new Date().setDate(new Date().getDate() + 3)).toISOString(), 
        action: 'Created by Jane Doe'
      },
      { 
        timestamp: new Date(new Date().setDate(new Date().getDate() + 3)).toISOString(),
        action: 'Approved by Customer Admin'
      }
    ]
  },
  { 
    id: 7, 
    employeeId: 102,
    employeeName: 'Jane Doe',
    customerId: 1, 
    customerName: 'Acme Inc.',
    projectId: 102,
    projectName: 'SEO Optimization',
    date: getDateString(-3), // 3 days ago
    hours: 6, 
    description: 'Keyword research and meta tags optimization',
    status: 'approved',
    history: [
      { 
        timestamp: new Date(new Date().setDate(new Date().getDate() - 3)).toISOString(), 
        action: 'Created by Jane Doe'
      },
      { 
        timestamp: new Date(new Date().setDate(new Date().getDate() - 2)).toISOString(), 
        action: 'Approved by Customer Admin'
      }
    ]
  },
  { 
    id: 8, 
    employeeId: 103,
    employeeName: 'Alex Johnson',
    customerId: 2, 
    customerName: 'Globex Corp.',
    projectId: 202,
    projectName: 'System Integration',
    date: getDateString(-5), // 5 days ago
    hours: 7, 
    description: 'Connected third-party payment processor API',
    status: 'approved',
    history: [
      { 
        timestamp: new Date(new Date().setDate(new Date().getDate() - 5)).toISOString(), 
        action: 'Created by Alex Johnson'
      },
      { 
        timestamp: new Date(new Date().setDate(new Date().getDate() - 4)).toISOString(), 
        action: 'Approved by Customer Admin'
      }
    ]
  },
  { 
    id: 9, 
    employeeId: 103,
    employeeName: 'Alex Johnson',
    customerId: 3, 
    customerName: 'Initech',
    projectId: 301,
    projectName: 'Database Migration',
    date: getDateString(5), // 5 days from now
    hours: 8, 
    description: 'Database schema design and validation',
    status: 'approved',
    history: [
      { 
        timestamp: new Date(new Date().setDate(new Date().getDate() + 5)).toISOString(), 
        action: 'Created by Alex Johnson'
      },
      { 
        timestamp: new Date(new Date().setDate(new Date().getDate() + 5)).toISOString(), 
        action: 'Approved by Customer Admin'
      }
    ]
  },
  { 
    id: 10, 
    employeeId: 101,
    employeeName: 'John Smith',
    customerId: 1, 
    customerName: 'Acme Inc.',
    projectId: 101,
    projectName: 'Website Redesign',
    date: getDateString(0), // Today (another entry)
    hours: 4, 
    description: 'Mobile responsive design implementation',
    status: 'pending',
    history: [
      { 
        timestamp: new Date().toISOString(), 
        action: 'Created by John Smith'
      }
    ]
  }
];